import type { ProgressInterface } from '@app/services/Progress/Progress'

import { createThunk } from '@app/store/thunk'

export function getProgress() {
  return createThunk((_dispatch, _getState, context) => context.lookupEnsure<ProgressInterface>(ProgressSymbol))
}
export function setProgress(value: ProgressInterface) {
  return createThunk((_dispatch, _getState, context) => context.getRootContext().set(ProgressSymbol, value))
}

const ProgressSymbol = Symbol('Progress')
